/**
 * Per-query opt-out from the global `QueryCache.onError` Sentry report, for queries where a
 * 404 is a normal answer rather than a failure (e.g. "no exchange rate for that date").
 * It only silences the report; the retry policy is unaffected and the page's own error state
 * still renders.
 */
export const QueryErrorReporting = {
  /** A 404 from this query is an expected "not found" answer and must not reach Sentry. */
  NotFoundExpected: 'notFoundExpected',
} as const;

export type QueryErrorReportingMeta = {
  [QueryErrorReporting.NotFoundExpected]?: true;
};

export const NOT_FOUND_EXPECTED_QUERY_META: QueryErrorReportingMeta = {
  [QueryErrorReporting.NotFoundExpected]: true,
};

declare module '@tanstack/react-query' {
  interface Register {
    queryMeta: QueryErrorReportingMeta;
  }
}
